// extracted by mini-css-extract-plugin
export default {"wrapper":"ArticleFooter_wrapper__a1LLm"};